"use strict";
// WARNING: DON'T PUT ANY PRIVATE OR SECRET API KEYS HERE!
// WE ARE ONLY ALLOWED TO EXPOSE PUBLIC API KEYS! 
Object.defineProperty(exports, "__esModule", { value: true });
exports.yotpo_STORE_ID = void 0;
exports.yotpo_STORE_ID = 'enXI2fSUbnLgPVrwWxvUtzYtXQuHhzI9B1abfKdR';
